import { useMutation } from "react-query";
import { bulkUpload } from "components/photography/lib/photoData";

export const useBulkUpload = () => {
    return useMutation(({ payload }) => {
        return bulkUpload(payload);
    });
};
